import { ROUTER_PATHS, useLoaders } from "@/shared";
import { useFetchGetByIdfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { Navigate, useParams } from "react-router-dom"
import SaveAgendamientoNoc from "../shared/componente/SaveAgendamientoNoc";

export default function CreateAgendamientoNoc() {

  const { idFactibilidad } = useParams()

  const { data, isLoading } = useFetchGetByIdfactibilidadCorporativos(idFactibilidad!);
  useLoaders(isLoading);

  if (isLoading) return null;
  if (!data?.data?.id_factibilidad_coorporativa)
    return <Navigate to={ROUTER_PATHS.noc.agendamientoNocNav} />;

  return (
    <SaveAgendamientoNoc
      titlePage="Crear Agendamiento NOC"
      factibilidadCorporativa={data.data}
    />
  )

}